export const SET_PAGE_TITLE = "SET_PAGE_TITLE";
export const CLEAR_PAGE_TITLE = "CLEAR_PAGE_TITLE";

export const setPageTitle = (title) => ({
  type: SET_PAGE_TITLE,
  payload: title,
});

export const clearPageTitle = () => ({
  type: CLEAR_PAGE_TITLE,
});